import { Box, CircularProgress, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import jsPDF from 'jspdf';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat, formatDNI } from '../../../../helpers';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { ENTITY_CONST } from '../../../auth/login/LoginReducer';
import { allCarnetAction } from '../../../carnet/CarnetAction';
import { captureElementToCanvasHelper } from '../../../carnet/CarnetHelper';
import { ACTIVO_CARNET, PARAMS_CARNET } from '../../../carnet/CarnetReducer';
import { ALTO_CARNET, ANCHO_CARNET, PDF_A4 } from '../../../carnet/ConstCarnet';
import FrontalCarnet from '../../../carnet/components/FrontalCarnet';
import LayoutCarnet from '../../../carnet/components/LayoutCarnet';
import ReverseCarnet from '../../../carnet/components/ReserveCarnet';
import {
  fullnameCarnet,
  getFullnames,
} from '../../../control_estudios/estudiantes/TodosCarnetsEstudiantes';
import BotonComponent from '../../../dashboard/components/BotonNuevo';

const TodosCarnetsUsuEntidades = ({ diseno }) => {
  const dispatch = Redux.useDispatch();

  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const carnetStore = Redux.useSelector((state) => state.carnet);

  const [loading, setLoading] = React.useState(false);
  const [tipoBoton, setTipoBoton] = React.useState(0);

  const [frontalRefs, setFrontalRef] = React.useState({});
  const [reverseRefs, setReverseRef] = React.useState({});
  const [qrRefs, setQrRef] = React.useState({});

  const ajustes = entidadesStore.ajustes;

  const values =
    usuEntidadesStore.selects.length > 0
      ? usuEntidadesStore.selects.filter((el) => el.usuario.perfil.avatar)
      : usuEntidadesStore.all.filter((el) => el.usuario.perfil.avatar);

  React.useEffect(() => {
    async function fetchData() {
      const payload = { idEntidad: entidadesStore.activo.id };
      dispatch({ type: PARAMS_CARNET, payload });
      const res = await allCarnetAction(dispatch, payload);

      const disenoCarnet = res.data.find((el) => {
        const { perfil } = el;
        return perfil && perfil.rol === ENTITY_CONST;
      });

      if (res.data.length > 0) {
        dispatch({ type: ACTIVO_CARNET, payload: diseno ?? disenoCarnet });
      }
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCompleto = async () => {
    setLoading(true);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);
    let count = 0;
    try {
      for (const el of values) {
        if (el.usuario.perfil.avatar === null) continue;

        const canvasFront = await captureElementToCanvasHelper(
          frontalRefs[el.id],
        );
        const dataCanvaFront = canvasFront.toDataURL('image/jpeg', 1.0);

        const canvasReverse = await captureElementToCanvasHelper(
          reverseRefs[`reversa${el.id}`],
        );
        const dataCanvaReverse = canvasReverse.toDataURL('image/jpeg', 1.0);

        const x = 100;
        const y = 25 + count * 247.4;
        // const y = 25 + count * 253.5;

        doc.addImage(dataCanvaFront, 'JPEG', x, y, ANCHO_CARNET, ALTO_CARNET);
        doc.addImage(
          dataCanvaReverse,
          'JPEG',
          x + 160.4,
          y,
          ANCHO_CARNET,
          ALTO_CARNET,
        );

        count++;
        if (count === 3) {
          doc.addPage();
          count = 0;
        }
      }

      doc.save(`PDF-CARNET-USUARIOS-${values.length}.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  const handleSoloFront = async () => {
    setLoading(true);
    setTipoBoton(2);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);

    let countRow = 0;
    let countColumn = 0;

    try {
      for (const el of values) {
        if (el.usuario.perfil.avatar === null) continue;

        const canvasFront = await captureElementToCanvasHelper(
          frontalRefs[el.id],
        );
        const dataCanvaFront = canvasFront.toDataURL('image/jpeg', 1.0);

        const x = 40 + countColumn * 168.5; // Ajusta el valor 150 según el espacio que necesites entre columnas
        const y = 25 + countRow * 253.5;

        doc.addImage(dataCanvaFront, 'JPEG', x, y, ANCHO_CARNET, ALTO_CARNET);

        countColumn++;
        if (countColumn === 3) {
          countColumn = 0;
          countRow++;
        }

        if (countRow === 3) {
          doc.addPage();
          countRow = 0;
        }
      }

      doc.save(`PDF-CARNET-SOLO-FRONTAL.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  const handleSoloQR = async () => {
    setLoading(true);
    setTipoBoton(3);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);
    let countRow = 0;
    let countColumn = 0;

    try {
      for (const el of values) {
        if (el.usuario.codeqr === null) continue;

        const codeqrRef = qrRefs[`codeqr${el.id}`];
        if (!codeqrRef.current) continue;

        const canvasQR = await captureElementToCanvasHelper(codeqrRef.current);
        const dataCanvaQR = canvasQR.toDataURL('image/jpeg', 1.0);

        const x = 40 + countColumn * 130; // Ajusta el valor 5 según el margen que necesites
        const y = 25 + countRow * 145;

        doc.addImage(dataCanvaQR, 'JPEG', x + 7.5, y + 6.5, 115, 115);
        doc.rect(x, y, 130, 145); // Agrega un borde alrededor de la imagen
        doc.setFont('arial', 'bold');
        doc.setFontSize(9);
        doc.text(
          `${el.usuario.perfil.tipoDni}-${el.usuario.perfil.dni.trim()}`,
          x + 65,
          y + 131,
          'center',
        );
        doc.setFont('arial');
        doc.setFontSize(9);
        doc.text(
          el.usuario.perfil.pnombre.trim() +
            ' ' +
            el.usuario.perfil.papellido.trim(),
          x + 65,
          y + 140,
          'center',
        );

        countColumn++;
        if (countColumn === 4) {
          countColumn = 0;
          countRow++;
        }

        if (countRow === 5) {
          doc.addPage();
          countRow = 0;
        }
      }

      doc.save(`PDF-CODIGOS-QR.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  function setDataCanvas() {
    setLoading(true);
    for (const el of values) {
      setFrontalRef((prevState) => ({
        ...prevState,
        [el.id]: React.createRef(),
      }));
      setReverseRef((prevState) => ({
        ...prevState,
        [`reversa${el.id}`]: React.createRef(),
      }));
      setQrRef((prevState) => ({
        ...prevState,
        [`codeqr${el.id}`]: React.createRef(),
      }));
    }
    setLoading(false);
  }

  const botonFull = (
    <BotonComponent
      text={
        Object.keys(frontalRefs).length > 0
          ? 'Descargar Carnets completo'
          : 'Generar carnet'
      }
      click={async () => {
        setTipoBoton(1);
        if (Object.keys(frontalRefs).length === 0) {
          setDataCanvas();
          return;
        }

        await handleCompleto();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 1}
      green={Object.keys(frontalRefs).length === 0}
      blue={Object.keys(frontalRefs).length > 0}
      mr={2}
    />
  );

  const botonSoloFrontal = (
    <BotonComponent
      text="Descargar Solo frontal"
      click={async () => {
        setTipoBoton(2);
        if (Object.keys(frontalRefs).length === 0) {
          setDataCanvas(2);
          return;
        }

        await handleSoloFront();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 2}
      green={Object.keys(frontalRefs).length === 0}
      blue={Object.keys(frontalRefs).length > 0}
      mr={2}
    />
  );

  const botonSoloQR = (
    <BotonComponent
      text="DEscargar Solo Código QR"
      click={async () => {
        setTipoBoton(3);
        if (Object.keys(qrRefs).length === 0) {
          setDataCanvas();
          return;
        }

        await handleSoloQR();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 3}
      green={Object.keys(qrRefs).length === 0}
      blue={Object.keys(qrRefs).length > 0}
    />
  );

  if (!carnetStore.activo) {
    return <h3>Falta el diseños del carnet</h3>;
  }

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sx={12} sm={12}>
          {botonFull}
          {Object.keys(frontalRefs).length > 0 && botonSoloFrontal}
          {Object.keys(qrRefs).length > 0 && botonSoloQR}
          <br />
          <strong>Cantidad seleccionados:</strong> {values.length}
          {'   '}
          <strong>Total de hojas:</strong> {Math.ceil(values.length / 3)}
        </Grid>

        <Grid item sx={12} sm={12}>
          {carnetStore.loadingAll ? (
            <center>
              <CircularProgress size="3rem" sx={{ mt: 4 }} />
            </center>
          ) : (
            values.map((el) => {
              const perfilEntidad = el.perfiles.find((el) => {
                const { rol } = el.perfil;
                return rol === ENTITY_CONST;
              });

              return (
                <div key={`carnet_${el.id}`} style={{ marginBottom: '30px' }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      {fullnameCarnet(el.usuario)}
                    </Grid>
                    <Grid item sx={12} sm={9}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <LayoutCarnet
                          cardRef={frontalRefs[el.id]}
                          bg={getFilesArchivos(carnetStore.activo.fondo)}
                        >
                          <FrontalCarnet
                            notEdit
                            data={{
                              photo: getFilesArchivos(el.usuario.perfil.avatar),
                              titleText: carnetStore.activo.titleText,
                              subtitleText: carnetStore.activo.subtitleText,
                              titleSeccionText:
                                carnetStore.activo.titleSeccionText,
                              titleNivelText: carnetStore.activo.titleNivelText,
                              ...getFullnames(el.usuario.perfil),
                              dni: `${el.usuario.perfil.tipoDni}-${formatDNI(
                                el.usuario.perfil.dni.trim(),
                              )}`,
                              periodo: `PERÍODO ${ajustes.periodoAcademico.desde}-${ajustes.periodoAcademico.hasta}`,
                              profile:
                                el.usuario.rol === ENTITY_CONST
                                  ? perfilEntidad.perfil.nombre
                                  : el.perfiles[0].perfil.nombre,
                              titleAgeText: carnetStore.activo.titleAgeText,
                              subtitleBackText:
                                carnetStore.activo.subtitleBackText,
                              age: dateformat(
                                el.usuario.perfil.fechaNacimiento,
                                { inverse: true },
                              ),
                            }}
                          />
                        </LayoutCarnet>
                        <LayoutCarnet
                          cardRef={reverseRefs[`reversa${el.id}`]}
                          bg={getFilesArchivos(carnetStore.activo.fondoBack)}
                          isReverse
                        >
                          <ReverseCarnet
                            qrRef={qrRefs[`codeqr${el.id}`]}
                            data={{
                              titleBackText:
                                carnetStore.activo.titleBackText.replaceAll(
                                  '{{perfil}}',
                                  el.perfiles[0].perfil.nombre.toLowerCase(),
                                ),
                              subtitleBackText:
                                carnetStore.activo.subtitleBackText,
                              titleFirmaText: carnetStore.activo.titleFirmaText,
                            }}
                            valueCodeqr={el.usuario.codeqr}
                            notEdit
                          />
                        </LayoutCarnet>
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
              );
            })
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TodosCarnetsUsuEntidades;
